import React, { CSSProperties } from 'react';
import { ExerciseCard } from './ExerciseCard';
import { RoutineExercise } from 'hevy-shared';
import { View } from 'styleguide/View';
import { Spacing } from 'styleguide/spacing';
import { TextLG, TextSMRegular } from 'styleguide/Texts';

interface SupersetGroupCellProps {
  exercises: RoutineExercise[];
  notes: string | null;
  title: string;
  style?: CSSProperties;
}

export const RoutineCell = ({ exercises, style, title, notes }: SupersetGroupCellProps) => {
  return (
    <View style={style}>
      <View style={{ paddingLeft: Spacing.sm }}>
        <TextLG>{title}</TextLG>
        {notes && <TextSMRegular>{notes}</TextSMRegular>}
      </View>
      {exercises.map((e, i) => (
        <ExerciseCard
          key={e.id + i}
          title={e.title}
          image={e.thumbnail_url || undefined}
          sets={e.sets}
        />
      ))}
    </View>
  );
};
